import React, { useState } from "react";
import { Mail, ArrowLeft } from "lucide-react";
import { Snackbar, Alert, Slide, Box } from "@mui/material";
import AuthService from "../../api/services/AuthService";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await AuthService.forgotPassword(email);

            setSnackbarMessage("Un lien de réinitialisation a été envoyé à votre adresse email.");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            setEmail("");
        } catch (err) {
            setSnackbarMessage(err.message || "Une erreur s'est produite.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.formContainer}>
                <div style={styles.header}>
                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: "15px" }}>
                        <svg
                            id="Calque_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 119.21 59.51"
                            style={{ width: "120px", height: "120px", cursor: "pointer" }}
                        >
                            <defs>
                                <style>
                                    {`
          .cls-1 {
            fill: url(#Dégradé_sans_nom_5);
          }
          .cls-2 {
            fill: #1d1d1b;
          }
          .cls-3 {
            fill: #263238;
          }
          .cls-4 {
            fill: url(#Dégradé_sans_nom_5-2);
          }
        `}
                                </style>
                                <linearGradient
                                    id="Dégradé_sans_nom_5"
                                    x1="10.92"
                                    y1="38.19"
                                    x2="-.42"
                                    y2="38.02"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop offset="0" stopColor="#3269ab" />
                                    <stop offset="1" stopColor="#8fc68b" />
                                </linearGradient>
                                <linearGradient
                                    id="Dégradé_sans_nom_5-2"
                                    x1="14.14"
                                    y1="29.76"
                                    x2="43.63"
                                    y2="29.76"
                                    xlinkHref="#Dégradé_sans_nom_5"
                                />
                            </defs>
                            <path
                                className="cls-2"
                                d="M41.43,47.74v1.99h5.96v5.86c-.87.62-1.82,1.1-2.84,1.44-1.03.35-2.05.52-3.09.52-1.67,0-3.22-.41-4.64-1.23-1.42-.82-2.55-1.92-3.38-3.32-.82-1.4-1.23-2.93-1.23-4.61s.41-3.14,1.21-4.52c0-.02.02-.03.03-.04.83-1.38,1.95-2.49,3.36-3.3,1.41-.82,2.94-1.23,4.62-1.23h.03c1.23,0,2.42.22,3.55.66,1.14.44,2.15,1.08,3.04,1.91l1.24-1.52c-1.05-.93-2.26-1.66-3.62-2.18-.9-.35-1.83-.58-2.78-.68-.47-.07-.97-.09-1.46-.09-2.06,0-3.97.49-5.72,1.48-1.74.98-3.12,2.31-4.14,3.99-.27.44-.49.89-.69,1.36-.55,1.3-.83,2.69-.83,4.17,0,2,.51,3.86,1.52,5.56,1.02,1.69,2.38,3.04,4.12,4.03,1.73.99,3.61,1.49,5.66,1.49,1.44,0,2.87-.26,4.3-.77,1.42-.5,2.65-1.2,3.7-2.09v-8.88h-7.92Z"
                            />
                            <path
                                className="cls-2"
                                d="M69.18,43.02v16.26h-2.11v-3.88c-.54,1.28-1.34,2.26-2.41,2.92-1.07.66-2.35,1-3.86,1.02-1.92,0-3.43-.56-4.52-1.69-1.09-1.13-1.63-2.67-1.63-4.64v-9.99h2.11v9.5c0,1.53.42,2.73,1.26,3.58s1.99,1.29,3.46,1.29c1.74-.02,3.1-.62,4.1-1.78.99-1.17,1.49-2.7,1.49-4.61v-7.98h2.11Z"
                            />
                            <path
                                className="cls-2"
                                d="M85.44,59.29l-.03-2.73c-.64.95-1.48,1.66-2.51,2.13-1.04.47-2.22.7-3.57.7-1.1,0-2.06-.21-2.9-.64-.84-.42-1.49-1.01-1.94-1.75s-.68-1.58-.68-2.51c0-1.41.54-2.51,1.63-3.32,1.09-.81,2.58-1.21,4.48-1.21h5.46v-1.24c0-1.28-.38-2.28-1.15-2.98-.77-.7-1.88-1.06-3.35-1.06-1.74,0-3.49.65-5.25,1.96l-.93-1.43c1.1-.77,2.14-1.33,3.14-1.69.99-.36,2.13-.54,3.41-.54,1.96,0,3.49.49,4.56,1.47,1.08.98,1.62,2.34,1.64,4.08l.03,10.77h-2.05ZM83.38,56.63c1-.67,1.68-1.62,2.03-2.84v-2.23h-5.25c-1.43,0-2.51.24-3.26.71-.74.48-1.12,1.19-1.12,2.14s.36,1.75,1.07,2.34,1.66.88,2.84.88c1.45,0,2.67-.34,3.68-1.01Z"
                            />
                            <path
                                className="cls-2"
                                d="M97.44,43.97c1-.65,2.21-.99,3.62-1.01v1.95c-1.72-.02-3.1.48-4.14,1.51-1.05,1.02-1.64,2.42-1.78,4.17v8.69h-2.08v-16.26h2.08v3.79c.54-1.24,1.31-2.19,2.31-2.84Z"
                            />
                            <path
                                className="cls-2"
                                d="M119.21,36.26v23.03h-2.08v-3.72c-.62,1.22-1.49,2.17-2.61,2.84-1.12.67-2.42,1.01-3.91,1.01s-2.9-.35-4.1-1.06c-1.2-.7-2.13-1.69-2.79-2.95-.66-1.26-.99-2.69-.99-4.28s.34-3.01,1.01-4.25c.67-1.24,1.6-2.21,2.79-2.92,1.19-.7,2.54-1.06,4.05-1.06s2.8.34,3.93,1.02c1.13.68,2,1.63,2.62,2.86v-10.52h2.08ZM114.15,56.79c.93-.55,1.66-1.31,2.19-2.28.53-.97.79-2.08.79-3.32s-.26-2.35-.79-3.34c-.53-.98-1.26-1.75-2.19-2.31-.93-.56-1.99-.84-3.17-.84s-2.23.28-3.17.84c-.93.56-1.67,1.33-2.2,2.31-.54.98-.81,2.09-.81,3.34s.26,2.35.79,3.32c.53.97,1.26,1.73,2.2,2.28.94.55,2,.82,3.18.82s2.23-.27,3.17-.82Z"
                            />
                            <path
                                className="cls-1"
                                d="M11.34,20.99v34.42c-2.43-1.15-4.65-2.58-6.61-4.23-.77-.64-1.5-1.32-2.19-2.03-.54-.56-1.06-1.14-1.55-1.73-.65-.79-.99-1.74-.99-2.71v-23.72h11.34Z"
                            />
                            <path
                                className="cls-3"
                                d="M11.31,0c-1.84,1-3.57,2.17-5.15,3.48h0c-.11.1-.21.19-.33.28-.04.02-.06.04-.09.08-1.15.99-2.22,2.06-3.2,3.2C1.62,8.11.77,9.24,0,10.42v.03h11.34V0h-.04Z"
                            />
                            <path
                                className="cls-3"
                                d="M26.06,18.01c-1.58.94-2.38-.3-3.84-.69l-5.73.66v-3.69l5.6.67c1.55-.08,2.04-1.74,3.89-.74,1.49.81,1.54,2.92.09,3.79Z"
                            />
                            <path
                                className="cls-4"
                                d="M43.63,15.67c0,9.1-6.85,15.72-16.08,15.72h-1.42v24.64h-.02v3.35c-.98.08-1.98.13-2.97.13-1.29,0-2.57-.08-3.81-.23-.79-.1-1.57-.22-2.34-.37-.97-.19-1.92-.42-2.85-.7V20.97h11.99c3.15,0,5.23-2.19,5.23-5.26s-2.08-5.27-5.23-5.27h-11.99V0h13.41c9.23,0,16.08,6.58,16.08,15.67Z"
                            />
                        </svg>
                    </Box>
                    <h2 style={styles.title}>Mot de passe oublié</h2>
                    <p style={styles.subtitle}>
                        Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe
                    </p>
                </div>

                <form style={styles.formContent} onSubmit={handleSubmit}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Adresse email</label>
                        <div style={styles.inputContainer}>
                            <Mail style={styles.icon} />
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={styles.input}
                                placeholder="votre@email.com"
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" style={styles.submitButton}>
                        Envoyer le lien
                    </button>

                    <div style={styles.backSection}>
                        <button
                            type="button"
                            onClick={() => window.history.back()}
                            style={styles.backButton}
                        >
                            <ArrowLeft style={{ width: "16px", height: "16px" }} />
                            Retour à la connexion
                        </button>
                    </div>
                </form>
            </div>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                TransitionComponent={Slide}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}

const styles = {
    container: {
        minHeight: "100vh",
        background: `linear-gradient(90deg, 
    #2a5fa9 0%, 
    #3a7fb5 20%,
    #4a9fc0 40%, 
    #5ab8a0 60%,
    #70bd8d 80%, 
    #8fc68b 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    },
    formContainer: {
        background: "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.6)",
        borderRadius: "16px",
        padding: "24px",
        width: "100%",
        maxWidth: "420px",
        margin: "0 auto",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    },
    header: {
        textAlign: "center",
        marginBottom: "32px",
    },
    title: {
        fontSize: "24px",
        fontWeight: "600",
        color: "#1f2937",
        marginBottom: "8px",
        marginTop: "0",
    },
    subtitle: {
        color: "#6b7280",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "1.5",
        margin: "0",
    },
    formContent: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
    inputGroup: {
        position: "relative",
    },
    label: {
        display: "block",
        fontSize: "14px",
        fontWeight: "500",
        color: "#374151",
        marginBottom: "8px",
    },
    inputContainer: {
        position: "relative",
    },
    input: {
        width: "100%",
        padding: "12px 16px 12px 44px",
        border: "1px solid #d1d5db",
        borderRadius: "10px",
        fontSize: "15px",
        background: "rgba(255, 255, 255, 0.7)",
        boxSizing: "border-box",
        outline: "none",
        transition: "border-color 0.3s, box-shadow 0.3s",
    },
    icon: {
        position: "absolute",
        left: "12px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#6b7280",
        width: "20px",
        height: "20px",
    },
    submitButton: {
        width: "100%",
        background: "linear-gradient(135deg, #2a5fa9 0%, #65b986 100%)",
        color: "white",
        fontWeight: "600",
        padding: "12px 24px",
        borderRadius: "10px",
        border: "none",
        cursor: "pointer",
        fontSize: "16px",
        boxShadow: "0 4px 12px rgba(42, 95, 169, 0.2)",
        transition: "transform 0.2s, box-shadow 0.2s",
    },
    backSection: {
        textAlign: "center",
        marginTop: "8px",
    },
    backButton: {
        background: "none",
        border: "none",
        color: "#2a5fa9",
        fontWeight: "500",
        cursor: "pointer",
        fontSize: "14px",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px",
        transition: "color 0.3s",
    },
};